module.exports = __webpack_public_path__ + "static/media/primary-care-modal-img.28a80cba.png";